import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faPhoneSquareAlt,
  faFax,
  faMobileAlt,
  faEnvelope,
  faCog,
  faUserTie,
  faBriefcase,
  faChartPie,
} from "@fortawesome/free-solid-svg-icons";
function CompanyOwnership() {
  return (
    <>
      <div className="company__detailes">
        <div className="company__detailes__left">
          <div className="boxShadow">
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faChartPie} size="lg" />
              <strong>Ownership Sturcture</strong>
            </p>
            <p>
              Almarai Company is a Saudi multinational dairy company which is
              listed on the Tadawul stock exchange. It specializes in food and
              beverage manufacturing and distribution. The company's main
              offices are located in Riyadh, Saudi Arabia,
            </p>
          </div>
        </div>
        <div className="company__detailes__right">
          <div className="boxShadow">
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faCog} size="lg" />
              <strong>Executive Management</strong>
            </p>
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faUserTie} size="lg" />
              <strong>Name: </strong>
              Majed Nofal
            </p>
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faBriefcase} size="lg" />
              <strong>Title: </strong>
              CEO
            </p>
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faPhoneSquareAlt} size="lg" />
              <strong>Telephone: </strong>
              +966 (11) 470 0005 0005
            </p>
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faFax} size="lg" />
              <strong>Fax: </strong>
              +966 (11) 470 1555
            </p>
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faMobileAlt} size="lg" />
              <strong>Mobile: </strong>
              +966 (11) 470 0005
            </p>
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faEnvelope} size="lg" />
              <strong>Email: </strong>
              info@almarai.com
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default CompanyOwnership;
